import ActionKeys from '../actions/ActionKeys';

const editOrderCode = {
    orderCode: '',
};

export const orderCodeReducer = (state = editOrderCode, action) => {
    switch (action.type) {
        case ActionKeys.ORDER_CODE_EDIT:
            return {
                ...state,
                orderCode: action.data,
            };

        default:
            return state;
    }
};
